import { useCallback, useRef, useState } from "react";
import { MoveHorizontal } from "lucide-react";

export function BeforeAfterSlider({ before, after, className = "" }) {
  const ref = useRef(null);
  const [pos, setPos] = useState(50);

  const update = useCallback((clientX) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    let p = ((clientX - rect.left) / rect.width) * 100;
    p = Math.max(0, Math.min(100, p));
    setPos(p);
  }, []);

  return (
    <div
      ref={ref}
      data-testid="before-after-slider"
      className={`relative w-full aspect-square overflow-hidden select-none cursor-ew-resize ${className}`}
      onPointerDown={(e) => { e.currentTarget.setPointerCapture(e.pointerId); update(e.clientX); }}
      onPointerMove={(e) => { if (e.buttons === 1) update(e.clientX); }}
    >
      {/* after (twilight) — base layer */}
      <img src={after} alt="Twilight" draggable="false" className="absolute inset-0 w-full h-full object-cover pointer-events-none" />
      {/* before (day) — clipped overlay */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
        <img src={before} alt="Daytime" draggable="false" className="absolute inset-0 w-full h-full object-cover" />
      </div>

      {/* labels */}
      <span className="absolute top-4 left-4 text-[10px] font-mono uppercase tracking-[0.2em] bg-black/40 text-white px-2 py-1 backdrop-blur-sm pointer-events-none">Day</span>
      <span className="absolute top-4 right-4 text-[10px] font-mono uppercase tracking-[0.2em] bg-black/40 text-white px-2 py-1 backdrop-blur-sm pointer-events-none">Twilight</span>

      {/* handle */}
      <div className="absolute top-0 bottom-0 w-px bg-white/90 pointer-events-none" style={{ left: `${pos}%` }}>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-11 w-11 rounded-full bg-white text-slate-900 shadow-lg flex items-center justify-center">
          <MoveHorizontal className="h-5 w-5" strokeWidth={1.75} />
        </div>
      </div>
    </div>
  );
}
